import React, { useState, useEffect } from 'react';
import './BookSwiper.css';
import { fetchSanadBooks } from '../../services/api';

const BookSwiper = () => {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedBook, setSelectedBook] = useState(null);

  // Fetch books from API
  useEffect(() => {
    const loadBooks = async () => {
      try {
        setLoading(true);
        const apiBooks = await fetchSanadBooks();
        
        if (apiBooks && apiBooks.length > 0) {
          // Transform API response to match component structure
          const transformedBooks = apiBooks.map(book => ({
            id: book.id,
            cover: book.cover || book.cover_image_url || '',
            pdf: book.pdf || book.pdf_url || ''
          }));
          setBooks(transformedBooks);
        } else {
          setBooks([]);
        }
      } catch (error) {
        console.error('Failed to load books:', error);
        setBooks([]);
      } finally {
        setLoading(false);
      }
    };

    loadBooks();
  }, []);

  const handleBookClick = (book) => {
    setSelectedBook(book);
  };

  const closeModal = () => {
    setSelectedBook(null);
  };

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        closeModal();
      }
    };
    if (selectedBook) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [selectedBook]);

  if (loading) {
    return (
      <div className="books-grid-container">
        <div className="text-center py-12">
          <p className="text-gray-500">Loading books...</p>
        </div>
      </div>
    );
  }

  if (books.length === 0) {
    return (
      <div className="books-grid-container">
        <div className="text-center py-12">
          <p className="text-gray-500">No books found.</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="books-grid-container">
        <div className="books-grid">
          {books.map((book) => (
            <div
              key={book.id}
              className="book-card"
              onClick={() => handleBookClick(book)}
            >
              <div className="book-cover-wrapper">
                <div className="book-cover">
                  <img 
                    src={book.cover} 
                    alt={`Book ${book.id}`}
                    loading="lazy"
                    onError={(e) => {
                      e.target.src = 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22300%22 height=%22400%22%3E%3Crect fill=%22%23e5e7eb%22 width=%22300%22 height=%22400%22/%3E%3Ctext fill=%22%239ca3af%22 font-family=%22sans-serif%22 font-size=%2214%22 dy=%2210.5%22 font-weight=%22bold%22 x=%2250%25%22 y=%2250%25%22 text-anchor=%22middle%22%3EBook Cover%3C/text%3E%3C/svg%3E';
                    }}
                  />
                  <div className="book-shine"></div>
                </div>
                <div className="book-spine"></div>
              </div>
              <div className="book-overlay">
                <div className="book-overlay-content">
                  <span className="book-view-icon">👁</span>
                  <span className="book-view-text">View PDF</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* PDF Modal */}
      {selectedBook && selectedBook.pdf && (
        <div className="pdf-modal" onClick={closeModal}>
          <div className="pdf-modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="pdf-modal-close"
              onClick={closeModal}
              aria-label="Close"
            >
              ×
            </button>
            <div className="pdf-viewer-container">
              <iframe
                src={`${selectedBook.pdf}#page=1`}
                title="PDF Viewer"
                className="pdf-viewer"
                frameBorder="0"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BookSwiper;

